module.exports = __webpack_public_path__ + "img/schedule.86875615.svg";